import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IFormAnswer } from '../models/contract-management.model';

@Injectable({
  providedIn: 'root'
})
export class SharedSourcesService {
  private sourcesSubject = new BehaviorSubject<{ questionId: string, sources: IFormAnswer['sources'] }>({ questionId: '', sources: [] });
  public sources$ = this.sourcesSubject.asObservable();
  public currentQuestionId: string = '';

  updateSources(sources: { questionId: string, sources: IFormAnswer['sources'] }) {
    this.currentQuestionId = sources.questionId;
    this.sourcesSubject.next(sources);
  }

  getCurrentSources(): { questionId: string, sources: IFormAnswer['sources'] } {
    return this.sourcesSubject.getValue();
  }
}